<script>
import _ from "lodash";

export default {
  name: "TheValueAttestationStudentTableDiv",

  props: {
    discipline: Object,
    student: Object,
  },

  computed: {
    attestationStudent() {
      return _.find(this.student.attestations, (attestation) => {
        return _.toNumber(attestation.disciplineId) === _.toNumber(this.discipline.id)
      })
    },

    value() {
      if(_.isNil(this.attestationStudent))  return "fa-times";

      if (this.attestationStudent.presence && _.isEmpty(this.attestationStudent.value) || _.isNil(this.attestationStudent.value)) return "A"

      if (this.attestationStudent.presence) return this.attestationStudent.value;

      if (!this.attestationStudent.presence) return "Н/А";

      return  "fa-question";
    },
  },


}
</script>

<template>
  <div>
    <span
      v-if="value !== 'fa-times'"
      :style="{'color': value === 'Н/А' || value === '2' || value === '1' ? 'red' : ''}"
      class="text-h5 bold"
    >
      {{value}}
    </span>
    <v-icon small v-else>
      {{value}}
    </v-icon>
  </div>
</template>

<style scoped>

</style>